import pino, { LoggerOptions } from 'pino';

const loggerOptions: LoggerOptions = {
  name: process.env.APP_ID || 'monopoli',
  level: process.env.LOG_LEVEL || 'debug',
  enabled: process.env.NODE_ENV !== 'test',
  transport: process.env.NODE_ENV === 'development'
    ? {
      target: 'pino-pretty',
      options: {
        colorize: true,
      },
    }
    : undefined,
};

export default pino(loggerOptions);
